// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadButton_container__3Xcut"};